var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#C58331"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#C58331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C24.6 16 19 21.3832 19 28.016C19 34.5207 24.3 39.8077 31.3333 40C31.4333 40 31.5667 40 31.6333 40C31.7 40 31.8 40 31.8667 40C31.9 40 31.9333 40 31.9333 40C38.6667 39.7757 43.9667 34.5207 44 28.016C44 21.3832 38.4 16 31.5 16Z",
    fill: "#C58331"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2866 55.5218C47.6998 60.7192 40.2298 63.92 32.0066 63.92C23.7833 63.92 16.3133 60.7192 10.7266 55.5218C11.4798 52.6378 13.52 50.0075 16.5017 47.9792C25.0702 42.2114 39.0057 42.2114 47.5115 47.9792C50.5246 50.0075 52.5333 52.6378 53.2866 55.5218Z",
    fill: "#C58331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profileImage.1287c3d027023f68cb9ddb7c88f926d5.svg";
export { ForwardRef as ReactComponent };